import * as React from 'react'

import { Text } from 'main/ui'
import { RegionSEOCopyContainer } from './RegionSEOCopy.styles'

interface IProps {
  city: string
}

export default function RegioSEOCopy(props: IProps) {
  const { city } = props

  return (
    <RegionSEOCopyContainer>
      <Text muted>
        Finding quality childcare in {city} has always been a challenge, and it is especially
        challenging right now. Wonderschool is a network of curated licensed family child care
        homes, forest schools, microschools and center-based childcare programs near you.
      </Text>
      <Text muted>
        There are many different types of daycares in {city} and you should pick child care that
        suit both yours and your child’s needs. Some providers may provide full-time care, while
        others provide part-time care. Not all childcare in {city} takes infants (12 months), some
        may take only toddlers (1-3 years) and preschoolers (3-5 years), so make sure you find a
        daycare that accommodates the age of your child.
      </Text>
      <Text muted>
        {city} has many family daycares, also known as in-home daycares, are usually run from the
        personal home of a child care provider, and focus on caring for a smaller number of children
        from the surrounding neighborhood. In-home daycares in {city} tend to have a low
        student-to-caregiver ratio, meaning more personal attention for your child. The home setting
        also provides a “home away from home” environment that some children may find more
        comfortable in.
      </Text>
      <Text muted>
        In addition to family daycares, {city} also has family child care centers. These are usually
        larger child care providers that serve a greater number of children, and may contain more
        shared amenities.
      </Text>
      <Text muted>
        Each state has its own definition of when a child care program needs to attain a child care
        license versus when a program can operate as license-exempt, and running a child care
        program in {city} is no different. A licensed daycare program will have to meet particular
        requirements and pass an inspection process to be sure their home is safe for children.
      </Text>
    </RegionSEOCopyContainer>
  )
}
